// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PHourglassOutlinedSvg from "@fishx/icons-svg/es/asn/PHourglassOutlined";
import FishxIcon from '../components/FishxIcon';

var PHourglassOutlined = function PHourglassOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PHourglassOutlinedSvg
  }));
};

PHourglassOutlined.displayName = 'PHourglassOutlined';
export default React.forwardRef(PHourglassOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PHourglassOutlined.js
// module id = 3456
// module chunks = 0